export const appConfig = {
  name: 'Entity Portal',
  defaultIframeUrl: 'https://example.com',
  logoPath: '/favicon.ico',
  logoAlt: 'Creditsafe',
} as const;
